import { template as template_0df15e03339e4db3ac1069259c91d0ee } from "@ember/template-compiler";
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { restartableTask, timeout } from 'ember-concurrency';
import type { LocalPath } from '@cardstack/runtime-common';
import Directory from './directory';
interface Signature {
    Args: {
        realmURL: string;
        selectedFile?: LocalPath;
        openDirs?: LocalPath[];
        onFileSelected?: (entryPath: LocalPath) => Promise<void>;
        onDirectorySelected?: (entryPath: LocalPath) => void;
        scrollPositionKey?: LocalPath;
    };
}
export default class FileTree extends Component<Signature> {
    static{
        template_0df15e03339e4db3ac1069259c91d0ee(`
    <nav>
      <Directory
        @relativePath=''
        @realmURL={{@realmURL}}
        @selectedFile={{@selectedFile}}
        @openDirs={{@openDirs}}
        @onFileSelected={{@onFileSelected}}
        @onDirectorySelected={{@onDirectorySelected}}
        @scrollPositionKey={{@scrollPositionKey}}
      />
      {{#if this.showMask}}
        <div class='mask' data-test-file-tree-mask></div>
      {{/if}}
    </nav>

    <style scoped>
      .mask {
        position: absolute;
        top: 0;
        left: 0;
        background-color: white;
        height: 100%;
        width: 100%;
      }
      nav {
        position: relative;
      }
    </style>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @tracked
    private showMask = true;
    constructor(owner: Owner, args: Signature['Args']){
        super(owner, args);
        this.hideMask.perform();
    }
    private hideMask = restartableTask(async ()=>{
        // fine tuned to coincide with debounce in RestoreScrollPosition modifier
        await timeout(300);
        this.showMask = false;
    });
}
